// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-product-card',
    // #endregion
    // #region Properties
    props: {
        product: {
            type: Object,
            required: false,
            default: {}
        },
        options: {
            type: Object,
            required: false,
            default: {}
        },
        mode: {
            type: String,
            required: false,
            default: 'products'
        },
    },
    data: () => ({
        cart: {
            quantity: 1,
            variantNumber: ""
        }
    }),
    // #endregion
    // #region Constructor
    created() {
        this.resetQuantity();
    },
    // #endregion
    // #region Core
    methods: {
        // #region Imges
        getImageUrl(product) {
            if (utils.isNull(product.images)) {
                return '';
            }
            return product.images[0].url;
        },
        // #endregion
        // #region Cart
        resetQuantity() {
            //Quantity
            this.cart.quantity = this.product?.quantityData?.min;
            //Optimiz
            if (!this.cart.quantity || this.cart.quantity == 0) {
                this.cart.quantity = 1;
            }
        },
        async OnToCart() {
            // #region Check
            if (!this.product) {
                return;
            }
            if (!this.product.canOrder) {
                return;
            }
            // #endregion
            // #region Data
            //Vars
            let tLine = {
                itemType: 'SKU',
                itemNumber: this.product?.itemNumber,
                quantity: this.cart?.quantity ?? 0,
                singlePrice: this.product?.price,
                priceUnit: this.product?.priceUnit,
                catalogID: this.product?.catalogID,
                options: []
            };
            let tCart = {
                cartID: this.$host.store.getter("carts/cartID"),
                accountID: this.$host.store.getter("session/accountID"),
                userID: this.$host.store.getter("session/userID"),
                lines: [tLine]
            };
            // #endregion
            // #region Send
            host.api.post('commerce/carts?mode=ifnotexists', tCart)
                .then(e => {
                // #region Store
                this.$store.commit('carts/setCart', e.data);
                // #endregion
                // #region Reset
                this.resetQuantity();
                // #endregion
                host.notification.showToast("Artikel wurde in den Warenkorb übernommen");
            })
                .catch(e => {
                host.notification.showToast(utils.getAxiosErrorMessage(e));
            });
            // #endregion
        }
        // #endregion
    }
    // #endregion
});
// #endregion
